var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body text-center"},[_c('img',{staticClass:"img-fluid",attrs:{"src":"/assets/smartcat/expired.png","width":"500","alt":"Responsive image"}}),_c('p',[_vm._v("Your MCR has expired.")])])])
}]

export { render, staticRenderFns }